import { connect } from 'react-redux';
import {
    actions
} from '../../../../../redux/modules/bodega/bodega';
import BodegaGrid from './BodegaGrid';

const mstp = state => {
    return {...state.bodegas, permisos: state.login.me.permisos, bodegas: state.login.me.bodegas}
};

const mdtp = {
    ...actions
};

export default connect(mstp, mdtp)(BodegaGrid)
